import React, { useEffect, useState } from "react";
import "./UsersRegister.scss";
import { motion, AnimatePresence } from "framer-motion";
import { fetchUsers, registerUser, fetchUsersByCategorie } from "../services/apiUsers";

export default function UsersRegister() {
  const mockUsers = [
    {
      id: 1,
      nom: "Jean Admin",
      email: "admin@gmail.com",
      phone: "099123456",
      categorie: 0,
    },
    {
      id: 2,
      nom: "Alice Acteur",
      email: "acteur@gmail.com",
      phone: "081654987",
      categorie: 1,
    },
  ];
  const [users, setUsers] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);
  const [currentTab, setCurrentTab] = useState(0); // 1 = non publié, 2 = publié
  const [savingIds, setSavingIds] = useState({});
  const [search, setSearch] = useState("");
  const rowsPerPage = 10;

  const [form, setForm] = useState({
    nom: "",
    email: "",
    phone: "",
    categorie: 1,
  });

  useEffect(() => {
    
    async function load() {
      try {
    
          const data = await fetchUsersByCategorie(currentTab);
           console.log("my response ",data);
          
          setUsers(data);
        } catch (err) {
        console.error(err);
        }
    }
    load();
  }, [currentTab]);

  async function handleSubmit(e) {

    e.preventDefault();
   

    const newUser = {
      id: users.length + 1,
      ...form,
      categorie: Number(form.categorie),
    };

    setUsers([...users, newUser]);
     try{
    const payload = {
        email: form.email,
        password: form.email,
        nom: form.nom,
        phone: form.phone,
        categorie:form.categorie,
        device_id:"",
      };


      const data = await registerUser(payload);
      console.log("✅ response data :", data);
    setOpenModal(false);
    setForm({ nom: "", email: "", phone: "", categorie: 1 });

} catch (err) {
    console.error("❌ Erreur lors de l'inscription :", err.response?.data || err.message);
  }
  };

  const categorieLabel = (value) =>
    value === '0' ? "Administrateur" : value === '1' ? "Acteur" : "Clients mobile";

    
  useEffect(() => {
    setFiltered(
      users.filter((v) =>
        v.nom.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, users]);

  
    const handleChangePage = (newPage) => {
      setPage(newPage);
    };
  
    const displayed = filtered.slice(
      (page - 1) * rowsPerPage,
      page * rowsPerPage
    );

  return (
    <div className="page-content">
      <div className="users-header">
        <h2>Gestion des utilisateurs</h2>
        <button onClick={() => setOpenModal(true)} className="btn-add">
          ➕ Ajouter utilisateur
        </button>
      </div>
      
      {/* Tabs */}
      <div className="tabs">
        <button
          className={`tab ${currentTab === 0 ? "active" : ""}`}
          onClick={() => setCurrentTab(0)}
        >
          Administrateurs
        </button>

        <button
          className={`tab ${currentTab === 1 ? "active" : ""}`}
          onClick={() => setCurrentTab(1)}
        >
          Acteurs
        </button>
        <button
          className={`tab ${currentTab === 2 ? "active" : ""}`}
          onClick={() => setCurrentTab(2)}
        >
          Clients mobile
        </button>
      </div>
       {/* Search / Filter */}
       <div className="filter-bar">
          <input
            type="text"
            placeholder="Filter users..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

      {/* TABLE */}
    <div className="vc-card">
      <table className="vc-table video-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Nom</th>
            <th>Email</th>
            <th>Téléphone</th>
            <th>Catégorie</th>
          </tr>
        </thead>
        <tbody>
          {displayed
            .map((user) => (
              <tr key={user.id}>
                <td>{user.id}</td>
                <td>{user.nom}</td>
                <td>{user.email}</td>
                <td>{user.phone}</td>
                <td>
                  <span
                    className={`badge ${
                      user.categorie === '0' ? "admin" : user.categorie === '1' ? "acteur" : "mobile" 
                    }`}
                  >
                    {categorieLabel(user.categorie)}
                  </span>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
    
      {/* Pagination */}
      <div className="pagination">
        <span>
          Rows per page: <b>{rowsPerPage}</b>
        </span>
        <span>
          {page} – {Math.ceil(filtered.length / rowsPerPage)} of{" "}
          {filtered.length}
        </span>
        <button
          disabled={page === 1}
          onClick={() => handleChangePage(page - 1)}
        >
          ‹
        </button>
        <button
          disabled={page * rowsPerPage >= filtered.length}
          onClick={() => handleChangePage(page + 1)}
        >
          ›
        </button>
      </div>


      {/* MODAL */}
      <AnimatePresence>
        {openModal && (
          <motion.div
            className="modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="modal"
              initial={{ scale: 0.9, y: 50 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 50 }}
            >
              <h3>Nouvel utilisateur</h3>
                <button
                className="vc-modal-close"
                onClick={() => setOpenModal(false)}
              >
                ✕
              </button>

              <form onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Nom complet"
                  value={form.nom}
                  required
                  onChange={(e) =>
                    setForm({ ...form, nom: e.target.value })
                  }
                />

                <input
                  type="email"
                  placeholder="Email"
                  value={form.email}
                  required
                  onChange={(e) =>
                    setForm({ ...form, email: e.target.value })
                  }
                />

                <input
                  type="tel"
                  placeholder="Téléphone"
                  value={form.phone}
                  required
                  onChange={(e) =>
                    setForm({ ...form, phone: e.target.value })
                  }
                />

                <select
                  value={form.categorie}
                  onChange={(e) =>
                    setForm({ ...form, categorie: e.target.value })
                  }
                >
                  <option value={0}>Administrateur</option>
                  <option value={1}>Acteur</option>
                </select>

                <div className="modal-actions">
                  <button
                    type="button"
                    className="badge admin"
                    onClick={() => setOpenModal(false)}
                  >
                    Annuler
                  </button>
                  <button type="submit" className="badge acteur">
                    Enregistrer
                  </button>
                </div>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
